module.exports = __webpack_public_path__ + "4931f467c0c2758720c4f803caa32fa0.woff";